import React from "react"
import { FormattedDate, FormattedMessage, FormattedTime, injectIntl } from "react-intl"
import Icon from "../../../../common/icon/icon.component.jsx"
import {Fingerprint, SavedSignature as StavedSignatureType, UserAgent} from "../../../../state/helpers/UserIdentity"

type Props = {
    signClassName: string,
    fingerprint: Fingerprint,
    userAgent: UserAgent,
    medium: string,
    savedSignature: StavedSignatureType,
}

function SavedSignature(props: Props) {
    return (<div className={"col-12"}>
        <div className={"row"}>
            <div className={props.signClassName + " py-3 " + props.medium}>
                <div className={"w-100 p-3 bg-light"}>
                    <div className={"w-100 mb-2"}>
                        <FormattedMessage
                            id="proposal.signature.singed_from_label"
                            defaultMessage="Electronically signed from:"
                        />
                    </div>
                    <div className={"w-100 d-flex "}>
                        <div className={"pr-3"} style={{ fontSize: "2em" }}>
                            <Icon value={"fingerprint"} />
                        </div>
                        <div className={"flex-grow-1"}>
                            <div className={"w-100"}>
                                <samp>{props.fingerprint.attributes.ip}</samp>
                            </div>
                            <div className={"w-100"}>
                                <samp>{props.fingerprint.attributes.city.toUpperCase()},
                                    {props.fingerprint.attributes.regionCode.toUpperCase()},
                                    {props.fingerprint.attributes.countryCode}</samp>
                            </div>
                        </div>
                    </div>
                    <div className={"w-100 text-break"}>
                        <small>
                            <samp>{props.userAgent.os.name} {props.userAgent.os.version} /
                                {props.userAgent.browser.name} {props.userAgent.browser.version}</samp>
                        </small>
                    </div>
                </div>
            </div>
            <div className={props.signClassName + props.medium}>
                <p className="mb-0">
                    <img src={props.savedSignature.attributes.signature} className="w-100 border-bottom border-dark mb-2" />
                </p>
                <div className={"w-100 d-flex justify-content-between"}>
                    <span>
                        {props.savedSignature.attributes.firstName} {props.savedSignature.attributes.lastName}
                    </span>
                    <span>
                        <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={new Date(props.savedSignature.attributes.createdAt)}
                        />
                        &nbsp;
                        <FormattedTime value={new Date(props.savedSignature.attributes.createdAt)} />
                    </span>
                </div>
            </div>
        </div>
    </div>)
}

export default injectIntl(SavedSignature)


// WEBPACK FOOTER //
// ./src/template/sections/content/signature/SavedSignatureComponent.tsx